export default function DialogFooter(props) {
    return <div style={{ display: "flex", justifyContent: "end", alignItems: "center", gap: "1em", position: "sticky", bottom: "0", paddingBlock: "20px", zIndex: "1001" }} className={props.className}>
        {props.children}
    </div>
}